import { usePanelNavigation } from './PanelNavigationContext';
import { ChevronLeft } from 'lucide-react';
import { LucideIcon } from '@/src/components/LucideIcon';
import { panelBackButton, panelHeaderContainer, panelTitle } from './panelHeader.styles';

type PanelHeaderProps = {
  title: string;
};

export function PanelHeader({ title }: PanelHeaderProps) {
  const { popPanel } = usePanelNavigation();

  return (
    <header className={panelHeaderContainer}>
      <button type="button" className={panelBackButton} onClick={popPanel} aria-label={`Back from ${title}`}>
        <LucideIcon icon={ChevronLeft} size="md" />
      </button>
      <h2 className={panelTitle}>{title}</h2>
    </header>
  );
}
